/**
 * Evaluates whether a value is considered truthy (boolean, string 'true', or number 1).
 * @param {*} value
 * @returns {boolean}
 */
export const isTrue = (value) =>
  value === true || value === 'true' || value === 1;
